import { PageHeroProps } from '../../ts'
import Desktop from './includes/Desktop'
import Mobile from './includes/Mobile'

function Image({ kind }: PageHeroProps) {
  return (
    <>
      <Desktop kind={kind} />
      <Mobile kind={kind} />
    </>
  )
}

export default Image
